import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import "./App.css"
import AuthProvider from "./context/AuthContext"
import AppRoutes from "./routes/AppRoutes"

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          pauseOnHover
          theme="light"
        />
        <AppRoutes />
      </AuthProvider>
    </div>
  )
}

export default App
